module.exports = __webpack_public_path__ + "static/img/picc7.9b29424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picc7.png
// module id = jQss
// module chunks = 0